import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetAssemblerOrderDetailsByOrderInput } from './GetAssemblerOrderDetailsByOrderInput';
import { GetAssemblerOrderDetailsByOrderOutput } from './GetAssemblerOrderDetailsByOrderOutput';

export class GetAssemblerOrderDetailsByOrderService extends HttpServiceBase {

  handle = (input: GetAssemblerOrderDetailsByOrderInput): Promise<Result<GetAssemblerOrderDetailsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetAssemblerOrderDetailsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order-assembly/${input.orderId}/details`);
    return promise;
  }
}